// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MaximizeOutlinedSvg from "@fishx/icons-svg/es/asn/MaximizeOutlined";
import FishxIcon from '../components/FishxIcon';

var MaximizeOutlined = function MaximizeOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MaximizeOutlinedSvg
  }));
};

MaximizeOutlined.displayName = 'MaximizeOutlined';
export default React.forwardRef(MaximizeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MaximizeOutlined.js
// module id = 3089
// module chunks = 0